import React, { useEffect, useRef } from "react";
import ErrorNotification from '../ErrorNotification';
import intlTelInput from "intl-tel-input";
import "intl-tel-input/build/css/intlTelInput.css";

const PhoneInputField = React.forwardRef((props, ref) => {
  const { id, name, label, error } = props;
  const phoneInputRef = useRef(null);

  useEffect(() => {
    if (phoneInputRef.current) {
      const itiInstance = intlTelInput(phoneInputRef.current, {
        loadUtilsOnInit: "https://cdnjs.cloudflare.com/ajax/libs/intl-tel-input/24.5.0/build/js/utils.min.js",
        strictMode: true,
        nationalMode: true,
        initialCountry: "auto",
        geoIpLookup: callback => {
          fetch("https://ipapi.co/json")
            .then(res => res.json())
            .then(data => callback(data.country_code))
            .catch(() => callback("us"));
        },
        formatOnDisplay: true,
        autoPlaceholder: "polite",
      });

      // Set itiInstance as ref
      if (ref) {
        ref.current = itiInstance;
      }
    }
  }, [ref]);

  return (
    <>
      <label htmlFor={id}>{label}</label>
      <input
        type="tel"
        id={id}
        className={error ? "border-danger" : "border-none"}
        ref={phoneInputRef}
        name={name}
      />
      {error && <ErrorNotification message={error} className="text-secondary" />}
    </>
  );
});

export default PhoneInputField;
